// MachineUtilizationDashboard/components/MachineDashboardSkeleton.jsx

function MachineDashboardSkeleton() {
  return (
    <div className="mud-skeleton-dashboard">
      <div className="mud-skeleton-kpis">
        {Array.from({ length: 5 }).map((_, index) => (
          <div className="mud-skeleton-card" key={index}>
            <span />
            <strong />
            <small />
          </div>
        ))}
      </div>

      <div className="mud-skeleton-large">
        <span />
      </div>

      <div className="mud-skeleton-two">
        <div>
          <span />
        </div>

        <div>
          <span />
        </div>
      </div>
    </div>
  );
}

export default MachineDashboardSkeleton;